import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Divider from '../../../divider/Divider';
import { useTheme } from '../../../theme-context';
import { ISeatInfo } from '../../types';

interface ISelectedSeatLine {
    seatInfo: ISeatInfo;
}

const SelectedSeatLine = ({
    seatInfo: { rowLabel, sectionLabel, tierColor, unitLabel },
}: ISelectedSeatLine): React.ReactElement => {
    const { getFont } = useTheme();
    return (
        <div>
            <div
                className={css({
                    display: 'grid',
                    gridTemplateColumns: '50% repeat(3, auto)',
                    gridGap: '4px',
                    padding: '14px',
                })}
            >
                <div
                    data-testid="section-title"
                    className={css({
                        fontFamily: getFont('desktop/body/small').fontFamily,
                        fontWeight: getFont('desktop/body/small').fontWeight,
                        fontSize: getFont('desktop/body/small').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/small').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {gettext('Section')}
                </div>
                <div
                    data-testid="row-title"
                    className={css({
                        fontFamily: getFont('desktop/body/small').fontFamily,
                        fontWeight: getFont('desktop/body/small').fontWeight,
                        fontSize: getFont('desktop/body/small').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/small').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {gettext('Row')}
                </div>
                <div
                    data-testid="seat-title"
                    className={css({
                        fontFamily: getFont('desktop/body/small').fontFamily,
                        fontWeight: getFont('desktop/body/small').fontWeight,
                        fontSize: getFont('desktop/body/small').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/small').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {gettext('Seat')}
                </div>
                <div
                    data-testid="tier-title"
                    className={css({
                        fontFamily: getFont('desktop/body/small').fontFamily,
                        fontWeight: getFont('desktop/body/small').fontWeight,
                        fontSize: getFont('desktop/body/small').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/small').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {gettext('Tier')}
                </div>
                <div
                    data-testid="section-label"
                    className={css({
                        fontFamily: getFont('desktop/body/medium/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/medium/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/medium/bold').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/medium/bold').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {sectionLabel}
                </div>
                <div
                    data-testid="row-label"
                    className={css({
                        fontFamily: getFont('desktop/body/medium/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/medium/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/medium/bold').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/medium/bold').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {rowLabel}
                </div>
                <div
                    data-testid="unit-label"
                    className={css({
                        fontFamily: getFont('desktop/body/medium/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/medium/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/medium/bold').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/medium/bold').lineHeightPx
                        }px`,
                        marginBottom: '4px',
                    })}
                >
                    {unitLabel}
                </div>
                <div
                    data-testid="tier-color"
                    className={css({
                        background: tierColor,
                        alignSelf: 'center',
                        borderRadius: '50%',
                        width: '14px',
                        height: '14px',
                        marginBottom: '4px',
                    })}
                />
            </div>
            <div data-testid="divider">
                <Divider />
            </div>
        </div>
    );
};

export default SelectedSeatLine;
